import React from 'react';

const menuItems = [
  { id: 'home', icon: '🏠', label: 'Dashboard' },
  { id: 'members', icon: '👥', label: 'Members' },
  { id: 'attendance', icon: '📋', label: 'Attendance' },
  { id: 'costumes', icon: '👘', label: 'Costumes' },
  { id: 'instruments', icon: '🎵', label: 'Instruments' },
  { id: 'fines', icon: '💰', label: 'Fines' },
  { id: 'announcement', icon: '📢', label: 'Announcement' },
  { id: 'schedule', icon: '📅', label: 'Class Schedule' },
  { id: 'performance', icon: '🎭', label: 'Performance Tracer' },
];

const AdminSidebar = ({ isOpen, activePage, setActivePage, onClose }) => {
  const handleClick = (id) => {
    setActivePage(id);
    onClose();
  };

  return (
    <div style={{ ...styles.sidebar, left: isOpen ? '0' : '-280px' }}>
      {/* Sidebar Header */}
      <div style={styles.sidebarHeader}>
        <div style={styles.logoBox}>
          <span style={styles.logoText}>DULIMBAY</span>
          <span style={styles.logoSub}>Culture & Arts Office</span>
          <span style={styles.logoSub}>Caraga State University</span>
        </div>
      </div>

      {/* Menu Items */}
      <div style={styles.menuList}>
        {menuItems.map((item) => (
          <button
            key={item.id}
            style={{
              ...styles.menuItem,
              ...(activePage === item.id ? styles.menuItemActive : {}),
            }}
            onClick={() => handleClick(item.id)}
          >
            <span style={styles.menuIcon}>{item.icon}</span>
            <span style={styles.menuLabel}>{item.label}</span>
            {activePage === item.id && <div style={styles.activeBar} />}
          </button>
        ))}
      </div>

      {/* Sidebar Footer */}
      <div style={styles.sidebarFooter}>
        <p style={styles.footerText}>Dulimbay System v1.0</p>
        <p style={styles.footerText}>Caraga State University</p>
      </div>
    </div>
  );
};

const styles = {
  sidebar: {
    position: 'fixed',
    top: '65px',
    left: '-280px',
    width: '260px',
    height: 'calc(100vh - 65px)',
    background: 'linear-gradient(180deg, #1a1a2e 0%, #16213e 100%)',
    zIndex: 999,
    transition: 'left 0.3s ease',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '4px 0 20px rgba(0,0,0,0.3)',
    overflowY: 'auto',
  },
  sidebarHeader: {
    padding: '25px 20px',
    borderBottom: '1px solid rgba(255,255,255,0.1)',
  },
  logoBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  logoText: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: '22px',
    letterSpacing: '3px',
  },
  logoSub: {
    color: 'rgba(255,255,255,0.5)',
    fontSize: '11px',
    marginTop: '2px',
    textAlign: 'center',
  },
  menuList: {
    flex: 1,
    padding: '15px 0',
  },
  menuItem: {
    width: '100%',
    padding: '14px 20px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    color: 'rgba(255,255,255,0.7)',
    fontSize: '14px',
    textAlign: 'left',
    position: 'relative',
    transition: 'all 0.2s',
  },
  menuItemActive: {
    background: 'rgba(255,255,255,0.1)',
    color: 'white',
    fontWeight: 'bold',
  },
  menuIcon: {
    fontSize: '18px',
    width: '24px',
    textAlign: 'center',
  },
  menuLabel: {
    flex: 1,
  },
  activeBar: {
    position: 'absolute',
    right: '0',
    top: '0',
    bottom: '0',
    width: '4px',
    background: '#e74c3c',
    borderRadius: '4px 0 0 4px',
  },
  sidebarFooter: {
    padding: '20px',
    borderTop: '1px solid rgba(255,255,255,0.1)',
    textAlign: 'center',
  },
  footerText: {
    color: 'rgba(255,255,255,0.3)',
    fontSize: '11px',
    margin: '2px 0',
  },
};

export default AdminSidebar;